import { useContext } from "react";
import { ParagraphText } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { Box } from "@mui/material";
import { SortArrow } from "../../../Features/NewInvoiceBook/InvoiceBookPages/InvoiceList";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const AccountDetailTableHeader = ({
  isAscending = false,
  isAscendingDetails = false,
  handleSort,
  isAppliedFilter,
  disabled = false,
}) => {
  const [I18n] = useContext(LanguageContext);
  return (
    <Box className="invoiceListTableHeader">
      <Box
        onClick={disabled ? undefined : () => { triggerLogEvent(analytics, "acc_txn_sort", { column: "date" }); handleSort("date") }}
        className={`invListTableHeaderCol fiveColumn textLeft sidebarOption ${disabled ? "" : "cursorPointer"}`}
      >
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.date}
        >
          {I18n.date}
          <SortArrow id="account_item_date_sort" isAscending={!isAscending} disabled={disabled} />
        </ParagraphText>
      </Box>
      <Box
        onClick={disabled ? undefined : () => { triggerLogEvent(analytics, "acc_txn_sort", { column: "details" }); handleSort("details") }}
        className={`invListTableHeaderCol fiveColumn textLeft ${disabled ? "" : "cursorPointer"}`}
      >
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor"}
          key={I18n.details}
        >
          {I18n.details}{" "}
        </ParagraphText>
      </Box>

      {!isAppliedFilter ? (
        <Box className={`invListTableHeaderCol fiveColumn textRight`}>
          <ParagraphText
            className={"fontSize12 fontWeight500 newLightColor textRight"}
            key={I18n.balance}
          >
            {I18n.balance}{" "}
          </ParagraphText>
        </Box>
      ) : null}

      <Box className={`invListTableHeaderCol fiveColumn textRight`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor textRight"}
          key={I18n.received}
        >
          {I18n.received}{" "}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol fiveColumn textRight`}>
        <ParagraphText
          className={"fontSize12 fontWeight500 newLightColor textRight"}
          key={I18n.given}
        >
          {I18n.given}{" "}
        </ParagraphText>
      </Box>
    </Box>
  );
};

export default AccountDetailTableHeader;
